export default __webpack_public_path__ + "static/media/banner5.02fdab03.png";